// ============================================
// compute 핸들러 — aiFieldConfig의 computes.handler에서 사용
// aiFieldConfig ↔ aiUtils 순환 참조 방지를 위해 별도 분리
// ============================================

const DATE_REMAINING_FIELDS = ['endDate', 'viewEndDate', 'expiryDate'];

// dot path 경로로 값 조회 //
function getByPath(obj, path) {
  if (obj == null) return undefined;
  if (path in obj) return obj[path];
  if (!path.includes('.')) return undefined;
  const traversed = path.split('.').reduce((o, k) => o?.[k], obj);
  if (traversed !== undefined) return traversed;
  return obj[path.split('.').pop()];
}

// 만료일 D-day 계산 + 정렬 //
export function addRemainingDays(items, columns) {
  const dateCol = columns.find(c => DATE_REMAINING_FIELDS.includes(c));
  if (!dateCol) return { items, hasRemainingDays: false };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const processed = items.map(item => {
    const dateVal = getByPath(item, dateCol) ?? item[dateCol];
    if (!dateVal) return { ...item, remainingDays: null };

    const raw = typeof dateVal === 'string' && dateVal.includes('T') ? dateVal.split('T')[0] : dateVal;
    const target = new Date(raw);
    target.setHours(0, 0, 0, 0);
    const days = Math.ceil((target - today) / (1000 * 60 * 60 * 24));

    return {
      ...item,
      _remainingDaysRaw: days,
      remainingDays: days > 0 ? `D-${days}` : days === 0 ? 'D-Day' : `D+${Math.abs(days)}`,
    };
  });

  // D-day 기준 정렬: D- 적은 순 → D-Day → D+ 적은 순
  processed.sort((a, b) => {
    const da = a._remainingDaysRaw ?? Infinity;
    const db = b._remainingDaysRaw ?? Infinity;
    const groupA = da === Infinity ? 3 : da > 0 ? 0 : da === 0 ? 1 : 2;
    const groupB = db === Infinity ? 3 : db > 0 ? 0 : db === 0 ? 1 : 2;
    if (groupA !== groupB) return groupA - groupB;
    return Math.abs(da) - Math.abs(db);
  });

  // 임시 필드 제거
  processed.forEach(item => { delete item._remainingDaysRaw; });

  return { items: processed, hasRemainingDays: true };
}

// 만료일 D-day 계산 (정렬 없이 값만) — 유저 정렬 적용된 경우 사용 //
export function addRemainingDaysNoSort(items, columns) {
  const dateCol = columns.find(c => DATE_REMAINING_FIELDS.includes(c));
  if (!dateCol) return { items, hasRemainingDays: false };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const processed = items.map(item => {
    const dateVal = getByPath(item, dateCol) ?? item[dateCol];
    if (!dateVal) return { ...item, remainingDays: null };

    const raw = typeof dateVal === 'string' && dateVal.includes('T') ? dateVal.split('T')[0] : dateVal;
    const target = new Date(raw);
    target.setHours(0, 0, 0, 0);
    const days = Math.ceil((target - today) / (1000 * 60 * 60 * 24));

    return {
      ...item,
      remainingDays: days > 0 ? `D-${days}` : days === 0 ? 'D-Day' : `D+${Math.abs(days)}`,
    };
  });

  return { items: processed, hasRemainingDays: true };
}

// 생년월일 → 나이 가상 컬럼 추가 //
export function addAge(items) {
  const today = new Date();
  return items.map(item => {
    const birthVal = item.birthDay || item.birthday || item.birthDate;
    if (!birthVal) return { ...item, age: null };

    const str = String(birthVal);
    const match = str.match(/^(\d{4})-?(\d{2})-?(\d{2})/);
    if (!match) return { ...item, age: null };

    const birthDate = new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]));
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return { ...item, age };
  });
}
